import { Theme } from '@material-ui/core/styles/createTheme';

const styles = (theme: Theme) => ({
  root: {
    padding: '1.25rem 2.5rem 1.5rem 1.25rem',
  },
});

export default styles;
